import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { actualizarCamionesCalados } from '../../actions'
import { TABLA_CAMIONES_CALADO_EN_CALLES } from '../../../../config/tables'

function TablaCalleCamionCalado (props) {
  useEffect(() => {
    props.actualizarCamionesCalados()
  }, [props])

  return (
    <div style={{ width: '100%' }} >
      <MuiTable id={TABLA_CAMIONES_CALADO_EN_CALLES} />
    </div>
  )
}
const mapActionsToProps = {
  actualizarCamionesCalados
}

export default (connect(null, mapActionsToProps)(TablaCalleCamionCalado))
